export default {"src":"/_next/static/media/logo.525bfdd5.svg","height":72,"width":273,"blurWidth":0,"blurHeight":0};